/* eslint-disable import/extensions */
import * as Yup from 'yup';
import "./yup/yupSchema.d.ts";

export default Yup;
